export enum EventPageType {
    Undefined = 0,
    RegistrationPage = 1,
    InformationPage = 2,
    AgendaPage = 3,
    SurveyPage = 4,
    SurveyActiveDeclinePage = 5,
    SurveyPassiveDeclinePage = 6,
    CustomPage = 7,
    WebinarWelcomePage = 8,
    WebinarThankYouPage = 9,
    GalleryPage = 10,
    SpeakersPage = 11,
    WorkshopsPage = 12
}
